import * as React from "react";
function SvgArrowRight(props, svgRef) {
  return <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M16 12L10 15.4641L10 8.5359L16 12Z" /></svg>;
}
const ForwardRef = React.forwardRef(SvgArrowRight);
export default ForwardRef;